<template>
    <div :class="['bo-panel', panelStyle]">
        <!-- HEADER  -->
        <div
            class="panel-header theme-secondary-bg-color"
            data-toggle="collapse"
            :data-target="'#' + panelId"
        >
            <div
                class="left-header"
                aria-expanded="false"
                :aria-controls="panelId"
            >
                <div class="indicator">
                    <i class="icon icon-expandmore"></i>
                </div>
                <i :class="['icon', icon]"></i>
                <span class="title">{{ title }}</span>
            </div>

            <div class="right-header">
                <span>{{ action }}</span>
            </div>
        </div>

        <!-- BODY  -->
        <div
            class="panel-body collapse show"
            :id="panelId"
        >
            <div class="panel-content">
                <slot name="content"> </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        panelId: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        action: {
            type: String,
            default: "",
        },
        panelStyle: {
            type: String,
            default: "",
        },
    },
};
</script>
